export default __webpack_public_path__ + "static/media/Twin house main cover.1418b172.jpg";